<bd-notes-editor [notesModel]="value"
                 [config.language]="language"
                 (notesModelChange)="onNotesChange($event)"
                 (focus)="onFocus()"
                 [ngClass]="{ 'ea-notes': isHubActivityFormEnabled, 'ea-notes-expanded': isExpanded }">
</bd-notes-editor>